<template>
	<div class="mt-1/8 ">
		<div v-if="expanded" class="f8 l0-3 text-navy flex flex-wrap">
			<span class="block mb-1/2">Travel dates</span>

			<div class="flex">
				<slot></slot>
				<button style="align-self: flex-end; transform: rotate(180deg)" @click="expanded = false">
					<svg class="w-1.5 h-1.5" width="29" height="9" viewBox="0 0 29 9" xmlns="http://www.w3.org/2000/svg">
						<title>Toggle Date List</title>
						<path d="M2 0l7 5v4L0 2l2-2zm14 0l2 2-9 7V5l7-5z" fill="#00b9f2" fill-rule="evenodd"/></svg>
				</button>
			</div>
		</div>
		<div class="f8 l0-3 text-navy" v-else>
			<span>Valid on select dates <span class="flex items-center whitespace-nowrap ml-1"> {{ shortrange }} <button v-if="length > 1" @click="expanded = true">
				<svg class="w-1.5 h-1.5" width="29" height="9" viewBox="0 0 29 9" xmlns="http://www.w3.org/2000/svg">
					<title>Toggle Date List</title>
					<path d="M2 0l7 5v4L0 2l2-2zm14 0l2 2-9 7V5l7-5z" fill="#00b9f2" fill-rule="evenodd"/></svg>
			</button></span></span>
		</div>
	</div>
</template>


<script>
import moment from 'moment-mini'
export default {
	props:['length', 'shortrange'],
	data() {
		return {
			expanded: false
		}
	},

}
</script>

<style lang='less'>

@import '../../../../public/bower_components/3l/3L/3L.less';
@import '../../less/variables';
@import '../../less/helpers';

button{
	border: 0;
	margin: 0 @magic/2;
	padding: 0;
	color: @cyan;
	cursor: pointer;
	font-size: 16px;
	background: transparent;
	.mobile({
		font-size: 30px;
	});
}

</style>


